import { $authHost } from '.';

// Выдает список терапий, назначенных врачом
export const getTherapies = async () => {
    const { data } = await $authHost.get('/therapies/');
    // **Ответ (200 OK):**
    // ```json
    // [
    //   {
    //     "id": 1,
    //     "patient": 1,
    //     "started_at": "2024-01-15T10:00:00Z",
    //     "ended_at": null,
    //     "illness_profile": 1,
    //     "assigned_by": 1,
    //     "device": 1
    //   }
    // ]
    // ```
    return data;
};

export const createTherapy = async (started_at, device_id, illness_profile_id, patientId) => {
    // **Запрос:**
    // ```json
    // {
    //   "started_at": "2024-01-15T10:00:00Z",
    //   "device_id": 1,
    //   "illness_profile_id": 1
    // }
    // ```
    const therapy = {
        started_at: started_at,
        device_id: device_id,
        illness_profile_id: illness_profile_id,
        patient_id: patientId,
    };
    const { data } = await $authHost.post('/therapies/', therapy);
    //     **Ответ (201 Created):**
    // ```json
    // {
    //   "id": 1,
    //   "patient": null,
    //   "started_at": "2024-01-15T10:00:00Z",
    //   "ended_at": null,
    //   "illness_profile": 1,
    //   "assigned_by": null,
    //   "device": 1
    // }
    // ```
    return data;
};

export const getOneTherapy = async (therapyId) => {
    const { data } = await $authHost.get(`/therapies/${therapyId}/`);
    // **Ответ (200 OK):**
    // ```json
    // {
    // "id": 1,
    // "patient": 1,
    // "started_at": "2024-01-01T10:00:00Z",
    // "ended_at": null,
    // "illness_profile": 1,
    // "assigned_by": 1,
    // "device": 1,
    // "spO2_value": 95  // Новое поле
    // }
    // ```
    return data;
};

export const updateTherapy = async (therapyId, therapyData) => {
    const { data } = await $authHost.put(`/therapies/${therapyId}/`, therapyData);
    return data;
};

export const deleteTherapy = async (therapyId) => {
    const { data } = await $authHost.delete(`/therapies/${therapyId}/`);
    return data;
};

// Получить терапии конкретного пациента
export const getPatientTherapies = async (patientId) => {
    const { data } = await $authHost.get(`/therapies/patients/${patientId}/`);
    return data;
};

// Получить комментарии к терапии
export const getTherapyComments = async (therapyId) => {
    const { data } = await $authHost.get(`/therapies/${therapyId}/comments/`);
    return data;
};

export const updateTherapySpO2 = async (therapyId, spO2_value) => {
    const new_spO2_value = { spO2_value: spO2_value };
    const { data } = await $authHost.patch(`/therapies/${therapyId}/`, new_spO2_value);
    return data;
};

// Добавить комментарий к терапии
export const createTherapyComment = async (therapyId, text) => {
    const comment = { text: text };
    const { data } = await $authHost.post(`/therapies/${therapyId}/comments/`, comment);
    return data;
};

